"use client";

import { HsvaColor } from "@noya-app/noya-color";
import { createContext, useContext } from "react";

export type ColorPickerContextValue = [
  hsva: HsvaColor,
  onChange: (color: Partial<HsvaColor>) => void,
];

const ColorPickerContext = createContext<ColorPickerContextValue | undefined>(
  undefined
);

export const ColorPickerProvider = ColorPickerContext.Provider;

export function useColorPicker(): ColorPickerContextValue {
  const value = useContext(ColorPickerContext);

  if (!value) {
    throw new Error("Missing ColorPickerProvider");
  }

  return value;
}
